/**
 * ModalEscCloser tracks a stack of arbitrary modals, and will close the top most
 * (most recently opened) modal when the Escape key is pressed,
 * by calling a `.close()` method on that modal.
 */
class ModalEscCloser {
  constructor() {
    this.stack = [];

    this.closeEsc = e => {
      if (e.key === 'Escape' && this.stack.length) {
        this.stack.pop().close();
      }
    };

    window.addEventListener('keydown', this.closeEsc);
  }

  /**
   * @param {modal} modal Any modal. Must expose a `.close()` method.
   */
  add(modal) {
    this.stack.push(modal);
  }

  remove(modal) {
    this.stack = this.stack.filter(m => m !== modal);
  }

  unload() {
    window.removeEventListener('keydown', this.closeEsc);
  }
}

export default new ModalEscCloser();
